var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10C19 9.73263 18.8977 9.49692 18.6931 9.29288L11.9095 2.31662C11.8004 2.20405 11.6878 2.12313 11.5719 2.07388C11.4628 2.02463 11.3468 2 11.224 2C10.9716 2 10.7602 2.08795 10.5897 2.26385C10.4191 2.43272 10.3339 2.64732 10.3339 2.90765C10.3339 3.0343 10.3543 3.15743 10.3953 3.27704C10.4362 3.38962 10.4976 3.48813 10.5794 3.57256L12.8713 5.97889L16.9332 9.79947L17.1379 9.27177L13.8433 9.06069H0.900377C0.634356 9.06069 0.416083 9.14864 0.245557 9.32454C0.0818525 9.50044 0 9.72559 0 10C0 10.2744 0.0818525 10.4996 0.245557 10.6755C0.416083 10.8514 0.634356 10.9393 0.900377 10.9393H13.8433L17.1379 10.7282L16.9332 10.2111L12.8713 14.0211L10.5794 16.4274C10.4976 16.5119 10.4362 16.6139 10.3953 16.7335C10.3543 16.8461 10.3339 16.9657 10.3339 17.0923C10.3339 17.3527 10.4191 17.5673 10.5897 17.7361C10.7602 17.912 10.9716 18 11.224 18C11.4696 18 11.6913 17.9015 11.8891 17.7045L18.6931 10.7071C18.8977 10.5031 19 10.2674 19 10Z",
    fill: "#706C69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/iconArrowRight.20e7d314ff52545009269ae153958215.svg";
export { ForwardRef as ReactComponent };